import * as Yup from "yup";
import Car from "../../../assets/categories/car.png";
import Telecoms from "../../../assets/categories/Telecoms.png";
import Logistics from "../../../assets/categories/Logistics.png";
import Ecomm from "../../../assets/categories/e-commerce.png";
import Payment from "../../../assets/categories/Payment.png";
import Goverment from "../../../assets/categories/Govt Repositories.png";
import OTT from "../../../assets/categories/OTTs.png";
import OTA from "../../../assets/categories/OTAs.png";
import POS from "../../../assets/categories/POS Companies.png";
import Food from "../../../assets/categories/Food Delivery.png";
import Meta from "../../../assets/categories/meta_6033716.png";
import GoogleAd from "../../../assets/categories/logo_15713432.png";
import DV360 from "../../../assets/categories/dv360.png";
import TradeDesk from "../../../assets/categories/trade_desk.png";

export const audienceObject = {
  ID: "",
  brandID: "",
  additionalFields: [],
  percentage: {
    value: 0,
  },
  isEditable: true,
  audience_group: "",
  mandatoryTrueCount: 0,
};

export const comingSoonChannels = [
  {
    channel: "The Trade Desk",
    image: TradeDesk,
  },
];

export const campaignChannels = [
  {
    channel: "Meta",
    image: Meta,
  },
  {
    channel: "DV360",
    image: DV360,
  },

  {
    channel: "Google Ads",
    image: GoogleAd,
  },
];

export const categories = [
  {
    title: "Automotive",
    image: Car,
  },
  {
    title: "Telecoms",
    image: Telecoms,
  },
  {
    title: "Logistics",
    image: Logistics,
  },
  {
    title: "E commerce",
    image: Ecomm,
  },
  {
    title: "POS Companies",

    image: Payment,
  },
  {
    title: "OTTs",
    image: OTT,
  },
  {
    title: "OTAs",
    image: OTA,
  },
  {
    title: "Payment Gateways",

    image: POS,
  },
  {
    title: "Food Apps",
    image: Food,
  },
  {
    title: "Government Repos",
    image: Goverment,
  },
];

export function getFields(fields, segments) {
  let groupedBySegment = {};
  segments.forEach((segment) => {
    const relatedFields = fields.filter(
      (field) => field.segment_id === segment.id
    );
    if (relatedFields.length > 0) {
      groupedBySegment[segment.id] = relatedFields;
    }
  });

  return groupedBySegment;
}

export function objectFromResponse(response) {
  let data = {};
  data = {
    ...audienceObject,
  };

  let additionalFields = [];
  for (let key of response.fields) {
    if (!key?.is_additional) {
      if (
        Array.isArray(Object.values(key)[0]) &&
        Object.values(key)[0]?.length > 0
      ) {
        data[Object.keys(key)[0]] = {
          value: Object.values(key)[0]?.length > 0 ? Object.values(key)[0] : [],
          mandatory: Object.values(key)[1] || false,
          userCount: Object.values(key)[3] || 0,
        };
      }

      if (
        typeof Object.values(key)[0] === "string" &&
        !!Object.values(key)[0]
      ) {
        data[Object.keys(key)[0]] = {
          value: !!Object.values(key)[0] ? Object.values(key)[0] : "",
          mandatory: Object.values(key)[1] || false,
          userCount: Object.values(key)[3] || 0,
        };
      }

      if (
        typeof Object.values(key)[0] === "object" &&
        !Array.isArray(Object.values(key)[0]) &&
        key[Object.keys(key)[0]]
      ) {
        data[Object.keys(key)[0]] = {
          value: key[Object.keys(key)[0]],
          mandatory: Object.values(key)[1] || false,
          userCount: Object.values(key)[3] || 0,
        };
      }

      if (
        typeof Object.values(key)[0] === "number" &&
        Object.values(key)[0] !== 0
      ) {
        data[Object.keys(key)[0]] = {
          value: Object.values(key)[0] !== 0 ? Object.values(key)[0] : 0,
          mandatory: Object.values(key)[1] || false,
          userCount: Object.values(key)[3] || 0,
        };
      }
    } else {
      additionalFields.push({
        key: Object.keys(key)[0],
        value: Object.values(key)[0],
        mandatory: key.mandatory,
      });
    }
  }

  return {
    ...data,
    percentage: data.percentage,
    ID: response.audience_id,
    brandID: response.brand_id,
    audience_group: data.audience_group,
    additionalFields: additionalFields,
    isEditable: response.is_editable,
    mandatoryTrueCount: response.mandatoryTrueCount,
    activeIndexes: response.active_indexes,
    contributors: { value: response.contributor_id },
    contributorsChecked: response.contributor_id?.length > 0 ? true : false,
  };
}

export function objectFromFormData(formData, details) {
  let fields = [];

  for (let field in formData) {
    if (
      field !== "ID" &&
      field !== "brandID" &&
      field !== "isEditable" &&
      field !== "additionalFields" &&
      field !== "dirty" &&
      field !== "mandatoryTrueCount" &&
      field !== "contributorsChecked" &&
      field !== "contributors" &&
      field !== "includedSegments" &&
      field !== "activeIndexes"
    ) {
      if (
        formData[field]?.value !== null &&
        formData[field]?.value !== undefined &&
        formData[field]?.value !== ""
      ) {
        fields.push({ [field]: formData[field] });
      }
    }
  }

  if (formData.additionalFields) {
    for (let addedFields of formData?.additionalFields) {
      fields.push({
        [addedFields.key]: {
          value: addedFields.value,
          mandatory: addedFields.mandatory || false,
          is_additional: true,
        },
      });
    }
  }

  return {
    brand_id: parseInt(details.activeBrand.ID),
    fields: fields,
  };
}

export function getAllAudiences(response) {
  let allAudiences = [];
  for (let key of response.data.audienceData) {
    let data = {};

    for (let fields of key.fields) {
      if (Array.isArray(Object.values(fields)[0])) {
        if (Object.values(fields)[0].length > 0) {
          data[Object.keys(fields)[0]] =
            Object.values(fields)[0].length > 0 ? Object.values(fields)[0] : [];
        }
      }

      if (typeof Object.values(fields)[0] === "string") {
        if (!!Object.values(fields)[0]) {
          data[Object.keys(fields)[0]] = !!Object.values(fields)[0]
            ? Object.values(fields)[0]
            : "";
        }
      }

      if (
        typeof Object.values(fields)[0] === "object" &&
        !Array.isArray(Object.values(fields)[0])
      ) {
        if (Object.keys(key)[0].length > 0) {
          data[Object.keys(fields)[0]] =
            Object.keys(key)[0].length > 0 ? Object.values(fields)[0] : {};
        }
      }
    }
    allAudiences.push({
      ...data,
      tentative_audience: key.tentative_size,
      category: key.category,
      isEditable: key.is_editable,
      audience_id: key.audience_id,
    });
  }
  return allAudiences;
}

export function schema(field) {
  let fields = [];
  for (let f in field) {
    fields.push(field[f]);
  }

  var validationSchema = Yup.object().shape({
    additionalFields: Yup.array().of(
      Yup.object().shape({
        key: Yup.string().required("Additional Fields Key is required"),
        value: Yup.string().required("Additional Fields Value is required"),
      })
    ),
    audience_group: Yup.object().shape({
      value: Yup.string()
        .min(3, "Greater than 3 letters")
        .required("Audience Group is required"),
    }),
  });

  for (let field of fields) {
    if (field?.control_id === 1) {
      validationSchema = validationSchema.concat(
        Yup.object({
          [field.name]: Yup.object().shape({
            value: Yup.object().shape({
              min: Yup.number()
                .nullable()
                .moreThan(
                  field.min_default_val - 1,
                  field.label +
                    " should be greater than " +
                    field.min_default_val
                )
                .lessThan(
                  field.max_default_val + 1,
                  field.label + " should be less than " + field.max_default_val
                ),
              max: Yup.number().when("min", {
                is: (val) => val,
                then: () =>
                  Yup.number()
                    .nullable()
                    .lessThan(
                      field.max_default_val + 1,
                      field.label +
                        " should be less than " +
                        field.max_default_val
                    )
                    .moreThan(Yup.ref("min"), "Max  should be greater")
                    .required(field.label + " is required"),
              }),
            }),
          }),
        })
      );
    }
  }

  return validationSchema;
}
